import { createContext } from "react";
import { pages } from "../config";
import {
  LoadingState,
  ModalState,
  OptionHeader,
  Question,
  Reviews,
  ReviewState,
  SnackbarInfo,
  StringObj,
} from "../type";
import { AlertColor } from "@mui/material";
import { DialogState } from "../taskpane/components/MyDialog";

export const ShowPageContext = createContext<{
  showPage: string;
  setShowPage: (page: string) => void;
}>({
  showPage: pages[0].id,
  setShowPage: () => {},
});

export const LoadingContext = createContext<{
  loadingState: LoadingState;
  handleLoadingOpen: (type: string, content: string) => void;

  handleLoadingClose: () => void;
}>({
  loadingState: {
    type: "",
    loading: false,
    content: "",
  },
  handleLoadingOpen: () => {},
  handleLoadingClose: () => {},
});

export const QuestionsContext = createContext<{
  questions: Question[];
  setQuestions: React.Dispatch<React.SetStateAction<Question[]>>;
  updateQuestions: (newQuestions: Question[], dontAddHistory?: boolean) => void;
  updateQuestionById: (id: string, question: Question) => void;
  removeQuestion: (index: number) => void;
  loadSheetData: (sheetType: string) => void;
  loadig: boolean;

  updateQuestionValue: (key: string, value: string | OptionHeader[]) => void;
  addQuestion: (insertIndex?: number) => void;
  addInitOption: (questionType: string) => void;
  selectedQuestion: Question | undefined;
  handleSelectedChange: (newSelected: number) => void;

  loadSheetNames: () => Promise<void>;
  sheets: string[];
  selectedSheet: string;
  handleChangeSheet: (sheet: string) => void;
  itemSheets: string[];
  selectedItemSheet: string;
  handleChangeItemSheet: (itemSheet: string) => void;
  autoSetBaseSheet: () => void;

  editSheet: string;
  updateEditSheet: (sheetName: string) => Promise<void>;

  generateQuestion: (target?: string) => Promise<void>;
  // generateQuestionText: () => Promise<void>;
  // generateQuestionOption: () => Promise<void>;

  handleChangeQuestionType: (newType: string) => void;
  isLoading: boolean;
  moveToNextQuestion: () => void;
  moveToPrevQuestion: () => void;
  getNextQuestion: () => number;
  getPrevQuestion: () => number;

  baseSheet: "form" | "item";
  handleChangeBaseSheet: (sheet: "form" | "item") => void;

  updateMatrixValue: (id: string, value: string, key: string) => void;
  updateOptionValue: (id: string, value: string, key: string) => void;

  researchInfo: StringObj;
  updateResearchInfo: (key: string, value: string) => void;

  historyIndex: number;
  undo: () => void;
  redo: () => void;
  isDeepThought: boolean;
  toggleDeepThought: () => void;
}>({
  questions: [],
  setQuestions: () => {},
  removeQuestion: () => {},
  updateQuestions: () => {},
  updateQuestionById: () => {},
  loadSheetData: () => {},
  loadig: false,

  updateQuestionValue: () => {},
  addQuestion: () => {},
  addInitOption: () => {},
  selectedQuestion: undefined,
  handleSelectedChange: () => {},
  autoSetBaseSheet: () => {},

  loadSheetNames: async () => {},
  sheets: [],
  selectedSheet: "",
  handleChangeSheet: () => {},
  itemSheets: [],
  selectedItemSheet: "",
  handleChangeItemSheet: () => {},
  editSheet: "",
  updateEditSheet: async () => {},

  generateQuestion: async () => {},

  handleChangeQuestionType: () => {},
  isLoading: false,
  moveToNextQuestion: () => {},
  moveToPrevQuestion: () => {},
  getNextQuestion: () => 0,
  getPrevQuestion: () => 0,

  baseSheet: "form",
  handleChangeBaseSheet: () => {},

  updateMatrixValue: () => {},
  updateOptionValue: () => {},

  researchInfo: {},
  updateResearchInfo: () => {},

  historyIndex: 0,
  undo: () => {},
  redo: () => {},

  isDeepThought: false,
  toggleDeepThought: () => {},
});

export const SnackbarContext = createContext<{
  snackbarOpen: boolean;
  snackbarInfo: SnackbarInfo;
  handleSnackbarOpen: (
    severity: AlertColor,
    message: string,
    options?: {
      // sx?: SxProps;
      anchorOrigin?: SnackbarInfo["anchorOrigin"];
    },
    duration?: number
  ) => void;
  handleSnackbarClose: (_: React.SyntheticEvent | Event, reason?: string) => void;
}>({
  snackbarOpen: false,
  snackbarInfo: {
    severity: undefined,
    message: "",
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
  },
  handleSnackbarOpen: () => {},
  handleSnackbarClose: () => {},
});

export const ModalContext = createContext<{
  modalState: ModalState;
  handleModalOpen: (content: string) => void;

  handleModalClose: () => void;
}>({
  modalState: {
    open: false,
    content: "",
  },
  handleModalOpen: () => {},
  handleModalClose: () => {},
});

export const ReviewContext = createContext<{
  reviews: Reviews;
  handleSetReview: (newReview: StringObj[], type: string) => void;
  handleSetReviews: (newReviews: Reviews) => void;
  reviewState: ReviewState;
  handleReviewState: (state: ReviewState) => void;
  reviewTypes: string[];
  handleChangeReviewType: (id: string) => void;
  handleChangeReviewTypeAll: () => void;
  reviewTargets: number[];
  handleChangeReviewTarget: (index: number) => void;
  handleChangeReviewTargetAll: (questions: any[]) => void;
  downloadReviewResults: (sheetType: string) => void;
  uploadReviewResults: (file: File, sheetType: string) => void;
  reviewFiles: {
    excel: string;
    llm: string;
  };
  removeReviewFile: (sheetType: string) => void;
  handleDismiss: (id: string, type: "excel" | "llm") => void;
  handleDone: (id: string, type: "excel" | "llm") => void;
  updateComments: (id: string, type: "excel" | "llm", comments: StringObj[]) => void;
  handleExcelReview: () => void;
  handleLLMReview: () => void;
  isExtraLoading: boolean;
  selectedId: string;
  handleSelectId: (id: string) => void;
  moveNeighborReview: (to: "next" | "prev") => void;
  resetState: () => void;
}>({
  reviews: {
    excel: [],
    llm: [],
  },
  handleSetReview: () => {},
  handleSetReviews: () => {},
  reviewState: "",
  handleReviewState: () => {},
  reviewTypes: [],
  handleChangeReviewType: () => {},
  handleChangeReviewTypeAll: () => {},
  reviewTargets: [],
  handleChangeReviewTarget: () => {},
  handleChangeReviewTargetAll: () => {},
  downloadReviewResults: async () => {},
  reviewFiles: {
    excel: "",
    llm: "",
  },
  uploadReviewResults: async () => {},
  removeReviewFile: () => {},
  handleDismiss: () => {},
  handleDone: () => {},
  updateComments: () => {},
  handleExcelReview: async () => {},
  handleLLMReview: async () => {},
  isExtraLoading: false,

  selectedId: "",
  handleSelectId: () => {},
  moveNeighborReview: () => {},

  resetState: () => {},
});

export const DialogContext = createContext<{
  dialogState: DialogState;
  handleDialogOpen: (title: string, content: string | JSX.Element, actions?: JSX.Element) => void;
  handleDialogClose: () => void;
}>({
  dialogState: {
    open: false,
    title: "",
    content: "",
  },
  handleDialogOpen: () => {},
  handleDialogClose: () => {},
});
